/**
 * An unsigned, decodable JWT for the non-backend auth paths: the E2E test
 * build, runtime mock mode, and Storybook. It carries the roles `useJwt`
 * consumers read so gated features render. Never sent to a real BFF — the
 * signature is a literal placeholder.
 *
 * `nowMs` is a parameter (not `Date.now()` inside) so callers control purity:
 * Storybook passes a fixed timestamp at module level, the app computes it once
 * in a `useState` initialiser.
 */
export const createMockJwtToken = ({
  nowMs,
  sub,
}: {
  nowMs: number;
  sub: string;
}): string => {
  const nowSeconds = Math.floor(nowMs / 1000);
  const payload = {
    sub,
    iss: "mock-issuer",
    aud: "webapp-customer",
    exp: nowSeconds + 3600, // 1 hour from now
    iat: nowSeconds,
    roles: {
      "jftechnology/pricing-engine": ["pricing-request:create"],
    },
  };

  const base64urlEncode = (obj: object) => {
    const json = JSON.stringify(obj);
    const base64 = btoa(json);
    return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
  };

  const header = { alg: "HS256", typ: "JWT" };
  const encodedHeader = base64urlEncode(header);
  const encodedPayload = base64urlEncode(payload);
  const mockSignature = "mock-signature";

  return `${encodedHeader}.${encodedPayload}.${mockSignature}`;
};
